import React from 'react';
import { Brand } from '../../core/context/claims';
import { Locale } from '../../core/locale/types';
import { useDevice } from '../../platform/device/useDevice';
import './AppStoreLink.css';

interface Props {
  brand: Brand;
  locale: Locale;
}

const STORE_URLS = {
  android: {
    [Brand.VIPPS]: 'https://play.google.com/store/apps/details?id=no.dnb.vipps',
    [Brand.MOBILEPAY]:
      'https://play.google.com/store/apps/details?id=fi.danskebank.mobilepay&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
  },
  ios: {
    [Brand.VIPPS]: 'https://apps.apple.com/no/app/vipps/id984380185',
    [Brand.MOBILEPAY]: 'https://apps.apple.com/us/app/mobilepay/id624499138',
  },
};

const AppStoreLink: React.FC<Props> = ({ locale, brand }) => {
  const isIOS = /iPad|iPhone|iPod/.test(useDevice().userAgent);
  const lang = locale.split('-')[0];

  const url = isIOS ? STORE_URLS.ios[brand] : STORE_URLS.android[brand];
  const imageUrl =
    isIOS ?
      `https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/${lang}-${lang}?size=250x83&amp;releaseDate=1386288000`
    : `https://play.google.com/intl/en_us/badges/static/images/badges/${lang}_badge_web_generic.png`;
  const altText = isIOS ? 'Download on the App Store' : 'Get it on Google Play';
  const linkClassName = `store-link${isIOS ? ' apple-link' : ''}`;

  return (
    <div className="app-upgrade-link">
      <a className={linkClassName} href={url}>
        <img src={imageUrl} alt={altText} />
      </a>
    </div>
  );
};

export default AppStoreLink;
